<div fxLayout='row' fxFill>
  <!-- Nav opener -->
  <div
    (click)='toggleMainSidenav()'
    class='main-drawer-slim-pane'
    *ngIf='cService.pageHeader.pageUiSettings?.hasMainNav'
  >
    <button
      mat-mini-fab
      vrm-raised-button
      class='main-drawer-toggle'
      [class.nav-opener-rtl]='cService.selectedLanguage.isRtl'
    >
      <mat-icon
        *ngIf='!cService.selectedLanguage.isRtl'
        class='rotate-item'
        style='position: relative; bottom: 6px'
        [class.right]='cService.mainSidenavOpened'
      >
        chevron_right
      </mat-icon>

      <!-- RTL -->
      <mat-icon
        *ngIf='cService.selectedLanguage.isRtl'
        class='rotate-item'
        style='position: relative; bottom: 6px'
        [class.right]='cService.mainSidenavOpened'
      >
        chevron_left
      </mat-icon>
    </button>
  </div>

  <!-- Page body -->
  <div class='page-body' fxFlex>
    <ng-content></ng-content>
  </div>
</div>
